import type { MultipleQueriesQuery } from "@algolia/client-search"

import { JOB_ADS_QUERY_KEY } from "@/modules/jobAds/client/api/constants"

export const getJobAdsFromAlgoliaQueryKeys = (query: MultipleQueriesQuery | undefined): unknown[] => {
  return [
    `${JOB_ADS_QUERY_KEY}::search`,
    "withAlgolia",
    {
      aroundLatLng: query?.params?.aroundLatLng || "",
      aroundRadius: query?.params?.aroundRadius || "",
      filters: query?.params?.filters || "",
      indexName: query?.indexName || "",
      optionalFilters: query?.params?.optionalFilters || "",
      page: query?.params?.page || 0,
      query: query || "",
    },
  ]
}
